import angular from 'angular';
import gridHeight from '../../../app/core/shared-service/grid-utils';

class MessageEpdfCtrl {
  /*@ngInject*/
  constructor(
    $sessionStorage,
    $state,
    $translate,
    dateFilter,
    MessageService,
    uiGridConstants,
    MESSAGE_STATUS,
    DematPlatformService,
    DateService,
    UtilSvc
  ) {
    this.$sessionStorage = $sessionStorage;
    this.$state = $state;
    this.$translate = $translate;
    this.dateFilter = dateFilter;
    this.MessageService = MessageService;
    this.uiGridConstants = uiGridConstants;
    this.MESSAGE_STATUS = MESSAGE_STATUS;
    this.DematPlatformService = DematPlatformService;
    this.DateService = DateService;
    this.UtilSvc = UtilSvc;
  }

  $onInit() {
    let vm = this;

    vm.criteriaMes = {
      messageId: [],
      messageStatus: [],
      batchId: [],
      dematError: [],
      invoiceId: [],
      acquitFrom: [],
      acquitTo: [],
      dematPlatformId: []
    };

    vm.criteriaDates = {
      requestedDateFrom: [],
      requestedDateTo: [],
      requestedTimeFrom: [],
      requestedTimeTo: [],
      updatedDateFrom: [],
      updatedDateTo: [],
      updatedTimeFrom: [],
      updatedTimeTo: []
    };

    vm.messagesStatus = vm.MESSAGE_STATUS;
    vm.getTableHeight = getTableHeight;

    vm.DematPlatformService.query(function(data) {
      vm.dematPlatforms = data;
    });
    vm.initCodeTreatments = function() {
      vm.codeTreatments = [];
      vm.MessageService.findCodeTreatments(function(data) {
        data.forEach(function(entry) {
          var obj = { value: entry };
          vm.codeTreatments.push(obj);
        });
      });
    };
    vm.initCodeTreatments();
    initMessagesSearchFilter();
    initMessagesSearchValues();

    // Paramètre indiquant si les critères de recherche doivent être initialisés suivant une configuration spéciale
    if (vm.specificForm === 'message_created') {
      // Critères de recherche par défaut OK
    } else if (vm.specificForm === 'message_sent') {
      vm.criteriaDates.requestedDateFrom = new Date(2015, 0, 1);
      vm.criteriaMes.messageStatus = 'SENT';
    }

    vm.clearSearchMessages = function() {
      initMessagesSearchFilter();
      initMessagesSearchValues();
      vm.messagesGridOptions.data = vm.MessageService.searchByCriterias(vm.criteriaMes);
      vm.$sessionStorage.messageHistorySearchCriteria = vm.criteriaMes;
    };

    vm.searchMessages = function() {
      cleanMessagesFormParam();

      var criterias = angular.copy(vm.criteriaMes);
      var requestedDateFrom = vm.UtilSvc.mixteDateTime(
        vm.criteriaDates.requestedDateFrom,
        vm.criteriaDates.requestedTimeFrom
      );
      criterias.requestedDateFrom = requestedDateFrom;
      var requestedDateTo = vm.UtilSvc.mixteDateTime(
        vm.criteriaDates.requestedDateTo,
        vm.criteriaDates.requestedTimeTo
      );
      criterias.requestedDateTo = requestedDateTo;
      var updatedDateFrom = vm.UtilSvc.mixteDateTime(
        vm.criteriaDates.updatedDateFrom,
        vm.criteriaDates.updatedTimeFrom
      );
      criterias.updatedDateFrom = updatedDateFrom;
      var updatedDateTo = vm.UtilSvc.mixteDateTime(vm.criteriaDates.updatedDateTo, vm.criteriaDates.updatedTimeTo);
      criterias.updatedDateTo = updatedDateTo;

      vm.messagesGridOptions.data = vm.MessageService.searchByCriterias(criterias);
      vm.messagePromise = vm.messagesGridOptions.data.$promise;
      vm.$sessionStorage.messageHistorySearchCriteria = vm.criteriaMes;
    };

    var defaultCellTemplate =
      '<a class="grid-cell-link" ui-sref="message_details({ messageId : row.entity.messageId })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" >{{COL_FIELD CUSTOM_FILTERS}}</div></a>';

    vm.messagesGridOptions = {
      columnDefs: [
        {
          name: 'messageId',
          displayName: 'dashboard.column.message.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          type: 'number',
          sort: { direction: vm.uiGridConstants.DESC, priority: 0 }
        },
        {
          name: 'messageStatus',
          displayName: 'dashboard.column.envelope.status',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          cellFilter: 'translate'
        },
        {
          name: 'updated',
          displayName: 'dashboard.column.folder.last.modified',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          cellFilter: "date:'short'"
        },
        {
          name: 'requested',
          displayName: 'dashboard.column.message.requested',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          cellFilter: "date:'short'"
        },
        {
          name: 'dematPlatformName',
          displayName: 'dashboard.column.message.platform',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'batchId',
          displayName: 'dashboard.column.batch.batch.id',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          type: 'number'
        },
        {
          name: 'recepted',
          displayName: 'dashboard.column.message.recepted',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          cellFilter: "date:'short'"
        },
        {
          name: 'dematError',
          displayName: 'dashboard.column.message.codeTreatment',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate'
        },
        {
          name: 'invoiceId',
          displayName: 'dashboard.column.message.invoiceId',
          cellTemplate: defaultCellTemplate,
          headerCellFilter: 'translate',
          type: 'number'
        }
      ],
      enableGridMenu: false,
      enableRowSelection: true,
      enableSelectAll: true,
      selectionRowHeaderWidth: 30,
      enableColumnMenus: false,
      exporterMenuCsv: false,
      exporterMenuPdf: false,
      exporterCsvColumnSeparator: ';',
      exporterOlderExcelCompatibility: true,
      exporterHeaderFilter: vm.$translate.instant,
      exporterFieldCallback: function(grid, row, col, value) {
        if (col.name === 'updated' || col.name === 'requested' || col.name === 'recepted') {
          value = vm.dateFilter(value, 'shortDate');
        } else if (col.name === 'messageStatus') {
          value = vm.$translate.instant(value);
        }
        return value;
      },
      gridMenuTitleFilter: vm.$translate,
      onRegisterApi: function(gridApi) {
        vm.gridMessagesApi = gridApi;
      }
    };

    (function() {
      var messageHistorySearchCriteria = vm.$sessionStorage.messageHistorySearchCriteria;
      if (messageHistorySearchCriteria && !vm.specificForm) {
        vm.criteriaMes = messageHistorySearchCriteria;
      }
    })();

    function initMessagesSearchValues() {
      vm.criteriaDates.requestedDateFrom = new Date();
      vm.criteriaDates.requestedDateFrom.setHours(0, 0, 0, 0);
      vm.criteriaDates.requestedDateTo = new Date();
      vm.criteriaDates.requestedDateTo.setHours(0, 0, 0, 0);
      vm.criteriaDates.requestedTimeFrom = new Date();
      vm.criteriaDates.requestedTimeFrom.setHours(0, 0, 0, 0);
      vm.criteriaDates.requestedTimeTo = new Date();
      vm.criteriaDates.requestedTimeTo.setHours(23, 59, 0, 0);
      vm.criteriaDates.updatedTimeFrom = new Date();
      vm.criteriaDates.updatedTimeFrom.setHours(0, 0, 0, 0);
      vm.criteriaDates.updatedTimeTo = new Date();
      vm.criteriaDates.updatedTimeTo.setHours(23, 59, 0, 0);
    }

    function cleanMessagesFormParam() {
      if (vm.criteriaMes.messageStatus === '') {
        vm.criteriaMes.messageStatus = undefined;
      }
      if (vm.criteriaMes.acquitFrom !== undefined) {
        vm.criteriaMes.acquitFrom.setHours(0, 0, 0, 0);
      }
      if (vm.criteriaMes.acquitTo !== undefined) {
        vm.criteriaMes.acquitTo.setHours(0, 0, 0, 0);
      }
    }

    function initMessagesSearchFilter() {
      vm.criteriaMes.messageId = undefined;
      vm.criteriaMes.messageStatus = undefined;
      vm.criteriaMes.batchId = undefined;
      vm.criteriaMes.dematError = undefined;
      vm.criteriaMes.invoiceId = undefined;
      vm.criteriaMes.dematPlatformId = undefined;
      vm.criteriaDates.requestedDateFrom = undefined;
      vm.criteriaDates.requestedDateTo = undefined;
      vm.criteriaDates.requestedTimeFrom = undefined;
      vm.criteriaDates.requestedTimeTo = undefined;
      vm.criteriaDates.updatedDateFrom = undefined;
      vm.criteriaDates.updatedDateTo = undefined;
      vm.criteriaDates.updatedTimeFrom = undefined;
      vm.criteriaDates.updatedTimeTo = undefined;
      vm.criteriaMes.acquitFrom = undefined;
      vm.criteriaMes.acquitTo = undefined;
    }

    // Indique si l'export CSV de la grille peut être réalisé
    vm.canExportGridCsv = function() {
      if (!(vm.gridMessagesApi === undefined || vm.gridMessagesApi.selection === undefined)) {
        return vm.gridMessagesApi.selection.getSelectedRows().length > 0;
      }
      return false;
    };

    // Exporte toutes les colonnes des lignes sélectionnées dans un fichier CSV
    vm.exportGridCsv = function() {
      // Nom du fichier CSV : epdf_DateHeure_dataMessages.csv
      var now = new Date();
      var filename = 'epdf_' + vm.DateService.formatAsYMD_HM(now) + '_dataMessages.csv';
      vm.messagesGridOptions.exporterCsvFilename = filename;

      var myElement = angular.element(document.querySelectorAll('.custom-csv-link-location'));
      vm.gridMessagesApi.exporter.csvExport('selected', 'all', myElement);
    };

    function getTableHeight() {
      return gridHeight(vm.gridMessagesApi);
    }
  }
}

angular.module('dashboard').component('messageEpdf', {
  templateUrl: require('./message.html'),
  controller: MessageEpdfCtrl,
  bindings: {
    specificForm: '<'
  }
});
